import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {marketingMobileCuttoff} from "@css/constants";
import {FontNormal} from "@css/fonts";
import {fontSize} from "@css/styles";
import {MissionTitleContainerProps} from "@pages/Homepage/components/MissionTitle/MissionTitle.elements";

export type MissionTextProps = {
  center: boolean
}

export const MissionMessageContainer = styled('div')(css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 30px;
`)

export const HeaderContainer = styled('div')(css`
  border-left: none;
  margin-top: 60px;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    border-left: 10px solid #4ca9ed;
    margin-top: 0;
  }
`)

export const HeaderContent = styled('div')(css`
  text-align: center;
  width: 90%;
  margin: 0 auto;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    text-align: start;
  }
`)

export const HeaderTitleTop = styled('p')(css`
  ${FontNormal(600)};
  ${fontSize(15)};
  color: #4ca9ed;
  text-transform: uppercase;
  padding-bottom: 10px;
 
  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(16)};
    padding: 5px 0;
  }
`)

export const HeaderTitle = styled('h3')(css`
  ${FontNormal(600)};
  ${fontSize(36)};
  max-width: 640px;
  margin: 0 auto;
  color: #1a1c1f;
 
  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(30)};
    padding-bottom: 5px;
    letter-spacing: -0.05em;
  }
`)

export const MissionMessageText = styled('div')<MissionTextProps>(props => css`
  text-align: ${props.center ? 'center' : 'start'};
  max-width: 475px;
  margin: 30px;
  ${FontNormal(400)};
  ${fontSize(16)};
  color: #1a1c1f;
 
  @media(max-width: ${marketingMobileCuttoff}) {
    max-width: 525px;
    text-align: start;
  }
`);

export const MissionMessageFirst = styled(MissionMessageText)(css`
  margin-bottom: 0;
`)

export const ImageContainer = styled('div')(css`
  margin: 0 auto;
  max-width: 475px;
 
  @media(max-width: ${marketingMobileCuttoff}) {
    margin: 0 30px;
  }
`)

export const StyledImage = styled('img')(css`
  height: 220px;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    height: 150px;
  }
`)

export const Quote = styled('p')(css`
  ${FontNormal(600)};
  ${fontSize(20)};
  font-style: italic;
  text-align: center;
  max-width: 475px;
  margin: 30px;
`)

export const StyledDiv = styled.div`
  width: 100%;
  text-align: start;
  max-width: 475px;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    width: 85%;
  }
`;

export const Sign = styled('p')(css`
  margin-bottom: 60px;
  max-width: 525px;
  ${FontNormal(400)};
  ${fontSize(16)};
  font-style: italic;
  text-align: start;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    margin: 30px auto;
  }
`)